import { render, staticRenderFns } from "./family_card.vue?vue&type=template&id=00789726&scoped=true"
import script from "./family_card.vue?vue&type=script&lang=js"
export * from "./family_card.vue?vue&type=script&lang=js"
import style0 from "./family_card.vue?vue&type=style&index=0&id=00789726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00789726",
  null
  
)

export default component.exports